import React from 'react';
import { Icon } from 'merchant-portal-components';

const ReadIcon = (props) => <Icon className="fab fa-readme" {...props} />;

export default ReadIcon;
